import axios from "axios"

export const sendSupportMsg = async (msg: any) => {
    await axios.post(process.env.NEXT_PUBLIC_API_URL + "supports/create", msg)
}
